import { t } from '../reportsManager';

const initialState = {
  deleteReportModalIsOpen: false,
};

const deleteReportModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.OPEN_DELETE_REPORT_MODAL: {
      return {
        ...state,
        deleteReportModalIsOpen: true,
      };
    }
    case t.CLOSE_DELETE_REPORT_MODAL: {
      return {
        ...state,
        deleteReportModalIsOpen: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default deleteReportModalReducer;
